import React from 'react';
import PropTypes from 'prop-types';
import Classes from '../common/Classes';
import {IconLink} from '../common/form';
import mixpanelConstants from '../common/mixpanelConstants';
import Utils from '../common/Utils';
import {faPhone, faGlobe, faEnvelope} from '@fortawesome/free-solid-svg-icons';

const ContactOptions = ({ exhibitor, translations, tags, tracker }) => (
    <ul data-testId="contact-options" className={Classes.contactOptionsContainerPackageRedesign}>
        {exhibitor.website ?
            <li className={Classes.contactOptionItemPackageRedesign}>
                <IconLink
                    className={Classes.contactOption}
                    href={exhibitor.website}
                    ariaLabel={translations.websiteButton}
                    content={translations.websiteButton}
                    tag={exhibitor.isPrioritySlotPremiumExhibitor ? tags.websiteLink + tags.prioritySlot : tags.websiteLink}
                    exhibitorId={exhibitor.id}
                    packageId={exhibitor.packageId}
                    iconClass={faGlobe}
                    openInNewTab
                    mixpanelProps={{
                        exhibitorId: exhibitor.id, exhibitorName: exhibitor.name,
                        component: mixpanelConstants.component.exhibitorDirectory,
                        packageName: Utils.getPackageName(exhibitor.packageId),
                        contactType: mixpanelConstants.contactType.website,
                        subComponent: exhibitor.isPrioritySlotPremiumExhibitor ? mixpanelConstants.subComponent.priority : mixpanelConstants.subComponent.standard
                    }}
                    tracker={tracker}
                />
            </li> : null
        }

        {exhibitor.email ?
            <li className={Classes.contactOptionItemPackageRedesign}>
                <IconLink
                    className={Classes.contactOption}
                    href={`mailto:${exhibitor.email}`}
                    ariaLabel={translations.emailButton}
                    content={translations.emailButton}
                    tag={exhibitor.isPrioritySlotPremiumExhibitor ? tags.emailLink + tags.prioritySlot : tags.emailLink}
                    exhibitorId={exhibitor.id}
                    packageId={exhibitor.packageId}
                    iconClass={faEnvelope}
                    mixpanelProps={{
                        exhibitorId: exhibitor.id, exhibitorName: exhibitor.name,
                        component: mixpanelConstants.component.exhibitorDirectory,
                        packageName: Utils.getPackageName(exhibitor.packageId),
                        contactType: mixpanelConstants.contactType.email,
                        subComponent: exhibitor.isPrioritySlotPremiumExhibitor ? mixpanelConstants.subComponent.priority : mixpanelConstants.subComponent.standard
                    }}
                    tracker={tracker}
                />
            </li> : null
        }
        {exhibitor.phone ?
            <li className={Classes.contactOptionItemPackageRedesign}>
                <IconLink
                    className={Classes.contactOption}
                    href={`tel:${exhibitor.phone}`}
                    ariaLabel={translations.phoneButtonTitle}
                    content={translations.phoneButtonTitle}
                    tag={exhibitor.isPrioritySlotPremiumExhibitor ? tags.phoneLink + tags.prioritySlot : tags.phoneLink}
                    exhibitorId={exhibitor.id}
                    packageId={exhibitor.packageId}
                    iconClass={faPhone}
                    mixpanelProps={{
                        exhibitorId: exhibitor.id, exhibitorName: exhibitor.name,
                        component: mixpanelConstants.component.exhibitorDirectory,
                        packageName: Utils.getPackageName(exhibitor.packageId),
                        contactType: mixpanelConstants.contactType.phone,
                        subComponent: exhibitor.isPrioritySlotPremiumExhibitor ? mixpanelConstants.subComponent.priority : mixpanelConstants.subComponent.standard
                    }}
                    tracker={tracker}
                />
            </li> : null
        }
    </ul>
);
ContactOptions.propTypes = {
    exhibitor: PropTypes.object.isRequired,
    translations: PropTypes.object.isRequired,
    tags: PropTypes.shape({
        phoneLink: PropTypes.string.isRequired,
        emailLink: PropTypes.string.isRequired,
        websiteLink: PropTypes.string.isRequired,
        prioritySlot: PropTypes.string.isRequired
    }).isRequired,
    tracker: PropTypes.object,
};

export default ContactOptions;
